import { type RefObject, useEffect, useRef } from 'react'

// Keeps a selected row visible: selection can move without a click — a slot
// preselected at mount from a URL-restored start/end, or one picked on the
// calendar grid rather than in the list. `nearest` makes this a no-op when the
// row is already in view, so clicking a visible row never scrolls the list, and
// the effect only runs on selection transitions, so it never fights the user's
// own scrolling afterwards.
export function useScrollIntoViewWhenSelected<T extends HTMLElement>(
  isSelected: boolean
): RefObject<T | null> {
  const ref = useRef<T>(null)
  useEffect(() => {
    if (isSelected) {
      ref.current?.scrollIntoView({ block: 'nearest' })
    }
  }, [isSelected])
  return ref
}
